const openMove = () => import(/* webpackChunkName: "Open router view" */ "../../views/openToMove/OpenToMove");
const application = () => import(/* webpackChunkName: "application.vue"*/ "../../views/openToMove/application.vue");
const DetailOpen = () => import(/* webpackChunkName: "DetailOpen.vue"*/ "../../views/openToMove/DetailOpen.vue");

const openToMove = [{
  path: "openMove",
  name: "Open Move",
  redirect: {
    name: "Application Open"
  },
  component: openMove,

  children: [
    {
      path: "applicationOpen",
      name: "Application Open",
      component: application
    },
    {
      path: "detailOpen",
      name: "Detail Open",
      component: DetailOpen
    },


  ]
}];

export default openToMove;
